import type { FC } from "react";
import React from "react";

import { bindArgs } from "@core/foundation/function";

import { Button } from "@react/ui-primitives/button";

import type { GithubRepo } from "@apis/memory/models";

interface GithubRepoTabsProps {
  readonly githubRepos: readonly GithubRepo[];
  readonly onSelect: (githubRepoId: number) => void;
  readonly selectedGithubRepoId: number;
}

export const GithubRepoTabs: FC<GithubRepoTabsProps> = ({
  githubRepos,
  onSelect,
  selectedGithubRepoId,
}) => (
  <div className="flex flex-wrap gap-2">
    {githubRepos.map(githubRepo => (
      <Button
        key={githubRepo.id}
        onClick={bindArgs(onSelect, githubRepo.id)}
        variant={githubRepo.id === selectedGithubRepoId ? "default" : "outline"}
      >
        {githubRepo.fullName}
      </Button>
    ))}
  </div>
);
